<template>
  <v-dialog :model-value="true" persistent max-width="400">
    <v-card class="text-center">
      <v-card-title class="pa-6">
        <v-icon icon="mdi-alert" color="warning" class="me-3" />
        Session Timeout Warning
      </v-card-title>

      <v-card-text>
        <p>You will be logged out in:</p>

        <v-chip color="error" size="large">
          {{ formatTime(remainingSeconds) }}
        </v-chip>
      </v-card-text>

      <v-card-actions>
        <v-btn variant="outlined" @click="$emit('logout')">
          Logout Now
        </v-btn>

        <v-btn color="primary" @click="$emit('stay-logged-in')">
          Stay Logged In
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
const props = defineProps({
  remainingSeconds: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['stay-logged-in', 'logout'])

const formatTime = (s) => {
  const m = Math.floor(s / 60)
  const r = s % 60
  return `${m}:${r.toString().padStart(2, '0')}`
}
</script>